/**
 * One-time migration of the persisted quotes-list status filter (#1498).
 * The whole Vuex store persists to localStorage, so changing the code default never reaches
 * an existing user. Version 2 introduced FINAL_CHECK: a saved set that still shows Incomplete
 * gets Final Check added once. A set that deliberately dropped Incomplete is left alone.
 */
export const QUOTE_FILTERS_VERSION = 2;

export function migrateQuoteFilters(filters: string[], version?: number): string[] {
	const current = version ?? 1;
	if (current >= QUOTE_FILTERS_VERSION) return [...filters];
	if (filters.includes("INCOMPLETE") && !filters.includes("FINAL_CHECK")) {
		return [...filters, "FINAL_CHECK"];
	}
	return [...filters];
}
